import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import { Icon } from '@mdi/react'

import theme from 'theme_'

export const StyledHeaderLinks = styled.nav<{ isMobile?: boolean }>`
  display: none;

  ${(p) =>
    p.isMobile &&
    `
      display: flex;
      flex-direction: column;

      ${StyledHeaderLink} {
        align-items: center;
        color: ${theme.colors.otterWarmBlack};
        display: flex;
        padding: 20px 25px;
        justify-content: space-between;

        &.active {
          background-color: ${theme.colors.activeState};
          color: ${theme.colors.otterWarmBlack};
      
          &:after {
            display: none;
          }

          ${StyledSelectedHeaderLinkIcon} {
            display: inline-block;
          }
        }

        @media ${theme.devices.desktop} {
          &:hover {
            background-color: ${theme.colors.activeState};
          }
        }
      }

      ${StyledHeaderLinkIcon} {
        display: inline-block;
      }
  `}

  @media ${theme.devices.desktop} {
    margin: 0;
    padding: 0;
    display: flex;
  }
`

export const StyledHeaderLink = styled(NavLink)`
  color: ${theme.colors.white};
  font-size: 18px;
  line-height: 14px;
  text-decoration: none;
  position: relative;
  padding: 25px 16px;

  &.active {
    color: ${theme.colors.horizonOrange};

    &:after {
      content: '';
      display: block;
      background-color: ${theme.colors.horizonOrange};
      width: 100%;
      height: 4px;
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }

  @media ${theme.devices.desktop} {
    &:hover {
      background-color: ${theme.colors.menuHover};
    }

    &:focus {
      background-color: ${theme.colors.otterWarmBlack};
    }
  }
`

export const StyledHeaderLinkTitle = styled.div`
  align-items: center;
  display: flex;
`

export const StyledHeaderLinkIcon = styled(Icon)`
  display: none;
  flex-shrink: 0;
  margin-right: 28px;
`

export const StyledSelectedHeaderLinkIcon = styled(Icon)`
  display: none;
`
